import { render, staticRenderFns } from "./ContextSettings.Invites.vue?vue&type=template&id=54bb2d04&scoped=true&"
import script from "./ContextSettings.Invites.vue?vue&type=script&lang=ts&"
export * from "./ContextSettings.Invites.vue?vue&type=script&lang=ts&"
import style0 from "./ContextSettings.Invites.vue?vue&type=style&index=0&id=54bb2d04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bb2d04",
  null
  
)

export default component.exports